import React from 'react'
import Flex from './Flex'
import { Spinner, SpinnerSize } from '@blueprintjs/core'

export default function LoadingMessage({ message, small }: { message?: string; small?: boolean }) {
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        height: small ? 50 : 200,
      }}
    >
      <Spinner size={SpinnerSize.SMALL} />
      <span style={{ paddingLeft: 10 }}>{message || 'Loading...'}</span>
    </Flex>
  )
}
